var smoothScroll = function smoothScroll(scrollTop) {
  return window.scrollTo({
    top: scrollTop,
    behavior: 'smooth'
  });
};

export default smoothScroll;